(() => {
  if (customElements.get('product-card')) {
    return;
  }
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.variantsSelect = this.querySelector('[data-product-select]');
      this.swatches = this.querySelectorAll('[data-swatches] input');
      this.media = this.querySelector('[data-product-media]');
      this.form = this.querySelector('form');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.quickviewTemplate = document.querySelector('#product-quickview');
      this.productTitle = this.dataset.productTitle;
      this.productId = this.dataset.productId;
      this.swatches.forEach((swatch) => {
        swatch.addEventListener('change', this.onSwatchChange.bind(this));
      })
      if (this.variantsSelect) {
        this.variantsSelect.addEventListener('change', this.onVariantChange.bind(this));
      }
      this.form && this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
    onSwatchChange(event) {
      const optionSelector = `option[data-option${
        event.target.dataset.optionPosition
      }="${event.target.value}"]`;
      this.variantsSelect.value = this.variantsSelect.querySelector(optionSelector).value;
      this.variantsSelect.dispatchEvent(new Event('change'));
    }
    onVariantChange(event) {
      const selectedOption = event.target.selectedOptions[0];
      this.querySelectorAll('[data-product-link]').forEach((link) => {
        link.setAttribute('href', `${this.dataset.url}${selectedOption.value}`)
      })
      if (!selectedOption.dataset.imageSrc || !selectedOption.dataset.imageSrcset) {
        return;
      }
      this.media.classList.remove('has-hover');
      if(this.media.querySelector('[data-secondary-image]')) {
        this.media.querySelector('[data-secondary-image]').style.display = 'none';
      }
      if(this.media.querySelector('[attr="data-secondary-image"]')) {
        this.media.querySelector('[attr="data-secondary-image"]').style.display = 'none';
      }
      if(this.media.querySelector('[data-primary-image]')) {
        this.media.querySelector('[data-primary-image]').src = selectedOption.dataset.imageSrc;
        this.media.querySelector('[data-primary-image]').srcset = selectedOption.dataset.imageSrcset;
      }
      if(this.media.querySelector('[attr="data-primary-image"]')) {
        this.media.querySelector('[attr="data-primary-image"]').src = selectedOption.dataset.imageSrc;
        this.media.querySelector('[attr="data-primary-image"]').srcset = selectedOption.dataset.imageSrcset;
      }
    }
    onSubmit(event) {
      event.preventDefault();
      const submitter = event.target.querySelector('[type="submit"]');
      const dispatchSubmit = submitter.hasAttribute('data-url');
      if (!dispatchSubmit) {
        this.addItemToCart();
        return;
      }
      if (window.modals && window.modals[`Product-Quickview-${this.productId}`]) {
        const quickview = window.modals[`Product-Quickview-${this.productId}`];
        this.attachQuickview(submitter, quickview);
        return;
      }
      fetch(`${submitter.dataset.url}&variant=${this.variantsSelect.value}`)
        .then((response) => response.text())
        .then((responseText) => {
          this.buildQuickView(submitter, responseText);
        })
    }
    buildQuickView(submitter, responseText) {
      const productDetails = new DOMParser()
        .parseFromString(responseText, 'text/html')
        .querySelector('[data-product-details]');
      const productFeaturedMedia = Array.from(
        new DOMParser()
        .parseFromString(responseText, 'text/html')
        .querySelectorAll('[data-product-media]')
      ).filter((media) => media.children[0].tagName.toLowerCase() !== 'modal-opener' && media.children[0].tagName.toLowerCase() !== 'deferred-media');
      const quickview = this.quickviewTemplate.content.cloneNode(true).querySelector('.product-quickview');
      quickview.id = `${quickview.id}${this.productId}`;
      quickview.querySelectorAll('[data-modal-close]').forEach((element) => {
        element.id = `${element.id}${this.productId}`;
      });
      if (quickview.querySelector('[role="dialog"]').ariaLabel) {
        quickview.querySelector('[role="dialog"]').ariaLabel =
          quickview.querySelector('[role="dialog"]').ariaLabel.replace('{{ product_title }}', this.productTitle);
      }
      productFeaturedMedia.forEach((media, index) => {
        media.children[0].setAttribute('data-product-quickview-media', '');
        if (index === 0) {
          return;
        }
        media.children[0].style.display = 'none';
      });
      quickview.querySelector('[data-media-wrapper]').innerHTML = Array.from(productFeaturedMedia).map((media) => media.innerHTML).join('');
      quickview.querySelector('[data-details-wrapper]').innerHTML = productDetails.innerHTML;
      this.attachQuickview(submitter, quickview);
    }
    attachQuickview(submitter, quickview) {
      document.body.append(quickview);
      setTimeout(() => {
        quickview.show(submitter);
      }, 1);
    }
addItemToCart() {
  const formData = new FormData(this.form);
  // Get the variant ID
  const variantId = this.variantsSelect.value;
  const config = {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          id: parseInt(variantId),
          quantity: 1
        }
      ],
      sections: ['main-cart-items'],
      sections_url: window.location.pathname
    })
  };
  fetch('/cart/add.js', config)
    .then(response => {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    })
    .then(() => {
      // This fetch gets updated section HTML
      return fetch(`/?sections=main-cart-items`);
    })
    .then(res => res.json())
    .then(sectionData => {
      const html = sectionData['main-cart-items'];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartItems = doc.querySelector('#main-cart-items');
      const currentCart = document.querySelector('#main-cart-items');
      if (newCartItems && currentCart) {
        currentCart.innerHTML = newCartItems.innerHTML;
      }
    })
    .catch(err => {
      console.error('Cart update failed:', err);
    });
}
  }
  customElements.define('product-card', ProductCard);
})();
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function() {
      const variantId = button.getAttribute('data-variant-id');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }],
          sections: ['main-cart-items'],
          sections_url: window.location.pathname
        })
      })
      .then(response => response.json())
      .then(() => {
        // Update the cart icon
        return fetch('/cart.js');
      })
      .then(cart => cart.json())
      .then(cart => {
        updateCartIcon(cart.item_count);
        
        const onCartPage = window.location.pathname === '/cart';
        if (!onCartPage) {
          window.location.href = '/cart';
          return;
        }

        // Re-fetch rendered section
        return fetch(`/?sections=main-cart-items`);
      })
      .then(res => res.json())
      .then(sectionData => {
        const html = sectionData['main-cart-items'];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartItems = doc.querySelector('#main-cart-items');
        const currentCart = document.querySelector('#main-cart-items');
        if (newCartItems && currentCart) {
          currentCart.innerHTML = newCartItems.innerHTML;
        }
      })
      .catch(error => console.error('Error adding to cart:', error));
    });
  });
  function updateCartIcon(itemCount) {
    const cartCountEl = document.querySelector('[data-js-cart-item-count]');
    if (cartCountEl) {
      cartCountEl.textContent = itemCount;
      cartCountEl.classList.add('is-active');
    }
  }
});